import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Função para formatar valor em formato monetário brasileiro
export function formatarMoeda(valor: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor)
}

// Converte qualquer representação de moeda para número
export function parsearMoeda(valor: string): number {
  if (!valor?.trim()) return 0
  const limpo = valor
    .replace(/R\$\s*/g, '')   // remove "R$ "
    .replace(/\./g, '')        // remove separadores de milhar
    .replace(',', '.')         // vírgula decimal → ponto
    .trim()
  return parseFloat(limpo) || 0
}

// Formata um número como moeda brasileira (para exibição e valores programáticos)
export function formatarMoedaInput(valor: number): string {
  if (!Number.isFinite(valor) || valor < 0) return 'R$ 0,00'
  return valor.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

// Máscara estilo calculadora para digitação (dígitos preenchem da direita)
export function aplicarMascaraMoeda(valor: string): string {
  const digitos = valor.replace(/\D/g, '')
  if (!digitos) return ''
  const numero = parseInt(digitos, 10) / 100
  return numero.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function normalizarWhatsApp(valor: string): string {
  return valor.replace(/\D/g, '')
}

export function formatarWhatsApp(valor: string): string {
  const digitos = normalizarWhatsApp(valor).slice(0, 11)
  if (digitos.length <= 2) return digitos
  if (digitos.length <= 6) return `(${digitos.slice(0, 2)}) ${digitos.slice(2)}`
  if (digitos.length <= 10) {
    return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 6)}-${digitos.slice(6)}`
  }
  return `(${digitos.slice(0, 2)}) ${digitos.slice(2, 7)}-${digitos.slice(7)}`
}

export function isWhatsAppValido(valor: string): boolean {
  const digitos = normalizarWhatsApp(valor)
  return digitos.length === 10 || digitos.length === 11
}
